export default "__VITE_ASSET__E7zVdabO__"